<template>
  <div class="timerHolder timerResponsive" :class="[editRequest ? 'editPlease' : '']">
    <div class="sizer">
      <timer-small class="smallerTimer" key="pie" :type="props.type" :bar-type="barType" />
      <div class="bigTimer">
        <timer-ring class="ring" key="ring" :type="props.type" :bar-type="barType" />
        <timer-numbers class="numbers" key="numbers" :type="props.type" />
      </div>
      <!-- <button v-if="props.barType === 'setTime'" class="editTime poster edit" @click="editPlease">Edit Time</button> -->
    </div>
  </div>
</template>
<script setup>
import { ref } from 'vue';
import TimerSmall from '@/components/TimerSmall.vue';
import TimerRing from '@/components/TimerRing.vue';
import TimerNumbers from '@/components/TimerNumbers.vue';

const props = defineProps({
  type: {
    type: String,
    default: 'phase',
  },
  barType: {
    type: String,
    default: 'phase',
  },
});
const editRequest = ref(false);
// const editPlease = () => {
//   editRequest.value = true;
// };//
</script>
<style lang="scss" scoped>
.timerHolder {
  position: relative;
  .sizer {
    margin: auto 0;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    container: --container-timer-holder / size;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
}

.editTime {
  font-weight: bold;
  display: none;
  transition: all 0.3s;
}

.smallerTimer {
  padding: rem(17px) 0;
  margin: rem(24px) 0;
  gap: rem(17px);
  align-items: center;
  justify-content: flex-start;
  display: none;
  :deep(.timerPie) {
    color: var(--timer-base);
    width: rem(52px);
    height: rem(52px);
  }
  :deep(.timerNumbers) {
    .unit,
    .number {
      display: inline-block;
    }
    .unit {
      margin-left: 0.5em;
    }
    .mins {
      color: var(--timer-base);
      font-size: rem(70px);
    }
  }
}

.bigTimer {
  padding: rem(10px) 0;
  flex: 0 0 auto;
  margin-top: auto;
  margin-bottom: auto;
  position: relative;
  width: rem(242px);
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr;
  .ring,
  .disc,
  .numbers {
    grid-row: 1;
    grid-column: 1;
  }
  .disc {
    //position: absolute;
    top: 0;
    opacity: 0;
    position: relative;
    left: rem(-5px);
    bottom: 0;
    // :deep(svg) {
    //   display: none;
    // }
  }
  :deep(.timeContainer) {
    top: 0rem;
    transition: transform $sidebar-duration $sidebar-ease-general;
    transform-origin: 50% 50%;
  }

  :deep(.numbers) {
    align-self: center;
    justify-self: center;
    text-align: center;
    margin: rem(3px) 0 0 rem(-16px);
    .unit {
      margin: rem(7px) 0 0 rem(5px);
    }
    .number,
    .unit,
    .total {
      line-height: 1;
    }
  }
}

@container --container-timer-holder (height < 16rem) {
  .bigTimer {
    //display: none;
    height: 12rem;
    width: 12rem;
    grid-template-columns: 12rem;
    grid-template-rows: 12rem;
    margin: 0 auto 1em auto;

    :deep(.timerRing),
    :deep(.markerCanvas) {
      height: 12rem;
      width: 12rem;
    }

    :deep(.track) {
      stroke-width: 4px;
    }

    :deep(.bar) {
      stroke-width: 8px;
    }

    :deep(.timerRing .setting .visibleDot),
    :deep(.timerRing .setting .invisibleDot) {
      r: 10px;
    }

    :deep(.numbers) {
      margin: rem(-5px) 0 0 rem(-5px);
      .mins {
        font-size: 4rem;
      }
      .unit {
        margin-top: 0em;
        @include type-size('x-small');
      }
    }
  }
}
@container --container-timer-holder (height < 12rem) {
  .bigTimer {
    display: none;
  }
  .smallerTimer {
    display: flex;
    :deep(.timerNumbers) {
      animation: grownIn $sidebar-duration $sidebar-ease-general;
    }
    :deep(.timerPie) {
      animation: grownIn $sidebar-duration $sidebar-ease-general;
    }
  }
  .editTime {
    display: block;
    opacity: 0;
    @include triggered {
      opacity: 1;
    }
  }
}
</style>
